import Swiper, { Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

document.querySelectorAll('.swiper.featured-clinics').forEach((el) => {
    const numberOfSlides = el.querySelectorAll('.swiper-slide').length;
    const swiper = new Swiper(el, {
        modules: [Pagination, Autoplay],
        spaceBetween: 14,
        pagination: {
            el: '.swiper-pagination',
        },
        autoplay: {
            delay: 5000,
        },
        loop: numberOfSlides > 4,
        watchOverflow: true,
        breakpoints: {
            900: {
                slidesPerView: 4,
            },
            700: {
                slidesPerView: 3,
            },
            500: {
                slidesPerView: 2,
            },
        },
    });
});
